import variables from '../design_tokens/heliguy-2024-designTokens-transformed.json'

export const primaryFont = variables.fontFamilies.poppins.value
export const secondaryFont = variables.fontFamilies['f37-bolton'].value
